import { useMemo } from "react";

import { StateEnveloped } from "../redux/helpers";
import { Locale } from "../models";
import { makeHookDeprecationWarn } from "../helpers/warnings";
import { useLocale } from "../next/hooks";
import { useUserGlobalActivity, useUserGlobalStatus } from "../next/hooks/user";

export type LocaleHookResult = StateEnveloped<Locale>;
export type LocaleHook = () => LocaleHookResult;

const deprecationWarn = makeHookDeprecationWarn("useLocale");

/**
 * @deprecated Use next.hooks.useLocale instead.
 */
const Hook: LocaleHook = () => {
  deprecationWarn();

  /**
   * Things are in an error state if we cannot get the user's preferred
   * locale for some reason. So, the 'state' of this hook depends
   * entirely on the state of the User slice.
   */
  const status = useUserGlobalStatus();
  const activity = useUserGlobalActivity();
  const locale = useLocale();
  const data = useMemo(
    () => ({
      locale,
    }),
    [locale],
  );

  const memoizedResult = useMemo(
    () => ({
      status,
      activity,
      data,
    }),
    [status, activity, data],
  );

  return memoizedResult;
};

export default Hook;
